import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import { useEffect, lazy, Suspense } from 'react';
import Header from '@/components/Header';
import ProtectedRoute from '@/components/ProtectedRoute';
import { ToastManager } from '@/components/ToastManager';
import { useUserStore } from '@/stores/user';
import { ProgressSpinner } from 'primereact/progressspinner';

import './App.scss';
import '@livekit/components-styles';

const CreateMeeting = lazy(() => import('@/pages/CreateMeeting'));
const Landing = lazy(() => import('@/pages/Landing'));
const Login = lazy(() => import('@/pages/Login'));
const Register = lazy(() => import('@/pages/Register'));
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('@/pages/ResetPassword'));
const VerifyEmail = lazy(() => import('@/pages/VerifyEmail'));
const Profile = lazy(() => import('@/pages/Profile'));
const Meeting = lazy(() => import('@/pages/Meeting'));
const VerifyAssistantInviteToken = lazy(() => import('@/pages/VerifyAssistantInviteToken'));
const MeetingMaterials = lazy(() => import('./pages/MeetingMaterials'));
const TgAiChat = lazy(() => import('@/pages/TgAiChat'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
    <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
  </div>
);

function App() {
  // Probe the auth cookie once on load (also picks up the session after an
  // OAuth provider redirects back into the SPA).
  useEffect(() => {
    useUserStore.getState().hydrate();
  }, []);

  return (
    <>
      <ToastManager />
      <div id="app">
        <BrowserRouter>
          <Header withBorder />
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<CreateMeeting />} />
              <Route path="/landing" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route path="/meeting/:meetingUid" element={<Meeting />} />
              <Route
                path="/meeting/assistant/:assistantInviteToken"
                element={<VerifyAssistantInviteToken />}
              />
              <Route path="/meeting/:meetingUid/materials" element={<MeetingMaterials />} />
              <Route path="/ai/answers/:answerUid" element={<TgAiChat />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
